module.exports =
  view: '/mockupServer/view/:templateIdentifier/:color/:size'
  render: '/mockupServer/render/:templateIdentifier/:color/:designId/:size.jpg'
  done: '/mockupServer/done'
  clippingMask: '/mockupServer/clippingMask/:templateIdentifier'
  v2:
    view: '/mockupServer/v2/view/:templateIdentifier/:side/:color/:size'
    preview: '/mockupServer/v2/preview/:templateIdentifier/:side/:color/:size'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/mockupServer.coffee